import React from 'react'
import { useProvidentNomination } from '../../Hooks/Features/WelcomeKit/useProvidentNomination'
import FormTable from './FormTable'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { dateConvert, RenderSignatureField } from '../../utils/Helper';
import { useCommanKit } from '../../Hooks/Features/WelcomeKit/useCommanKit';
import CommanDialog from '../CommonCompo/CommanDialog/CommanDialog';

const ProvidentFund = ({ label, onPrev, onNext, data, readOnly }) => {
    const { fieldData, formValues, nomineeTable, handleDelete, callAPI, showPopup, setShowPopup, familyData } =
        useProvidentNomination({ label, onNext, data });
    const { signature, handleChange, handleRemove } = useCommanKit({ data });

    return (
        <div className='my-2'>
            <div className='w100'>
                <h4 className="p-2" style={{ background: "#f2f2f2" }}>Provident Fund Nomination</h4>
                <div>
                    <div className='text-right my-4'>
                        <span> Employee code: <strong>{data?.employee?.employee_id}</strong></span>
                    </div>
                    <div className='text-center'>
                        <div className='d-flex justify-content-center my-2'>
                            <div style={{ borderStyle: "double" }}>
                                <h4 className='px-2 text-center'>Form 2 (Revised)</h4>
                            </div>
                        </div>
                        <p>(For Unexempted /Exempted Establishments)</p>
                        <h5 className='my-2'>NOMINATION AND DECLARATION FORM</h5>
                        <p className='my-2'>
                            (Declaration and Nomination Form under the Employees’ Provident Funds and Employees’ Pension Scheme)
                        </p>
                        <strong className='my-2' style={{ fontSize: "14px" }}>
                            (Paragraphs 33 &amp; 61 (1) of the Employees’ Provident Funds Scheme, 1952 and paragraph 18 of the Employees’ Pension Scheme, 1995)
                        </strong>
                    </div>
                </div>
                <section>
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <th className='w25'>Name (in Block Letters)</th>
                                <td>{formValues?.employee_pf_nomination?.[0]?.user_display_name}</td>
                            </tr>
                            <tr>
                                <th  className='w30'>Father’s/Husband’s Name</th>
                                <td>{formValues?.employee_pf_nomination?.[0]?.fatherOrHusbandName}</td>
                            </tr>
                            <tr>
                                <th>Date of Birth</th>
                                <td>{formValues?.employee_pf_nomination?.[0]?.birth_date && dateConvert(formValues?.employee_pf_nomination?.[0]?.birth_date, "day-mon-year")}</td>
                            </tr>
                            <tr>
                                <th>Sex</th>
                                <td>{formValues?.employee_pf_nomination?.[0]?.gender}</td>
                            </tr>
                            <tr>
                                <th>Marital Status</th>
                                <td>{formValues?.employee_pf_nomination?.[0]?.marital_status}</td>
                            </tr>
                            <tr>
                                <th>Account No.(PF/UAN Number)</th>
                                <td>{formValues?.employee_pf_nomination?.[0]?.uan_number}</td>
                            </tr>
                            <tr>
                                <th>Address (Residential)</th>
                                <td>
                                    <div><strong>Permanent:</strong> {formValues?.employee_pf_nomination?.[0]?.permanent_contact_address}</div>
                                    <div><strong>Temporary:</strong> {formValues?.employee_pf_nomination?.[0]?.present_contact_address}</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </section>
                <section>

                    {Object.entries(fieldData).map(([section, fields]) => {
                        return <>
                            {fields?.isFormTable && fields?.isFormTable !== undefined &&
                                <div className='my-5'>
                                    <h5 className='text-center bold'>{section}</h5>
                                    <p style={{ fontSize: "16px", fontWeight: "600" }}>{fields?.subTitle}</p>
                                    <FormTable onPrev={onPrev} onNext={onNext} label={label} fieldsDetails={{ [section]: fields }} data={data} IsTitle={"no"} notTable={true} handleAPI={callAPI} row={formValues} familyList={familyData} readOnly={readOnly} />
                                    {
                                        fields?.key === "employee_epf_part_a" && <div>
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Name and Address of the nominee/ nominees</th>
                                                        <th>Nominee’s relationship with the member</th>
                                                        <th style={{ width: "100px" }}>Date of Birth</th>
                                                        <th>Total amount or share of accumulations in Provident Fund to be paid to each nominee (%)</th>
                                                        <th>If the nominee is a minor, name, relationship, and address of the guardian who may receive the amount during minority of nominee</th>
                                                        <th>Whether residing with him/her</th>
                                                        <th colSpan={2}>If 'No' state Place of Residence</th>
                                                        {
                                                            !readOnly && <th>Action</th>
                                                        }
                                                    </tr>
                                                    <tr>
                                                        <th colSpan={6}></th>
                                                        <th colSpan={1}>Town</th>
                                                        <th colSpan={1}>State</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {formValues[section]?.map((nominee, index) => {
                                                        return <tr key={index}>
                                                            <td>{nominee?.member_name}</td>
                                                            <td>{nominee?.family_relation}</td>
                                                            <td>{dateConvert(nominee?.date_of_birth, "day-mon-year")} </td>
                                                            <td>{nominee.nominee_percentage}</td>
                                                            <td>
                                                                {nominee.minor === 'Yes'
                                                                    ? (
                                                                        <>
                                                                            <div>Name: {nominee?.gardian_name}</div>
                                                                            <div>Relationship: {nominee?.guardianRelationship}</div>
                                                                            <div>Address: {nominee?.gardian_address_data}</div>
                                                                        </>
                                                                    )
                                                                    : 'N/A'}
                                                            </td>
                                                            <td>{nominee?.is_residing_with_relative}</td>
                                                            <td>{nominee?.is_residing_with_relative ? nominee?.residence_town || 'Not provided' : 'N/A'}</td>
                                                            <td>{nominee?.is_residing_with_relative ? nominee?.residence_town || 'Not provided' : 'N/A'}</td>
                                                            {
                                                                !readOnly && <td>  <FontAwesomeIcon
                                                                    icon="fa-solid fa-trash"
                                                                    style={{ cursor: "pointer" }}
                                                                    onClick={() => setShowPopup({ visibel: true, section, row: nominee })}
                                                                /> </td>
                                                            }
                                                        </tr>
                                                    })}
                                                    <tr>
                                                        <td colSpan="3" style={{ fontWeight: 'bold', textAlign: 'right' }}></td>
                                                        <td colSpan="5" style={{ fontWeight: 'bold' }}>{nomineeTable(formValues[section]) || 0} %</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <p style={{ fontSize: "14px", fontWeight: "600" }}>1 * Certified that I have no family as defined in para 2(g) of the Employees’ Provident Funds Scheme, 1952, and should I acquire a family hereafter, the above nomination should be deemed as cancelled.</p>
                                            <p style={{ fontSize: "14px", fontWeight: "600" }}>2 * Certified that my father/mother is/are dependent upon me.</p>
                                            <p style={{ fontSize: "14px", fontWeight: "600" }}>3. * Strike out whichever is not applicable.</p>
                                            <p style={{ fontSize: "14px", fontWeight: "600" }}>Note: - A Fresh nomination shall be made by the member on his marriage and any nomination made before such marriage shall be deemed to be invalid.</p>

                                            <div className='my-5'>
                                                <p className='text-decoration-underline'># If Married –&gt; Spouse, Children (married or unmarried), his/her dependent parents, deceased son’s widow and children. </p>
                                                <p className='text-decoration-underline'># If unmarried then Parents, Brother, Sister or any other person(s)</p>
                                            </div>

                                        </div>
                                    }
                                    {
                                        (fields?.key === "employee_eps_part_1" || fields?.key === "employee_eps_part_2") && <div>
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Name</th>
                                                        <th>Date of Birth</th>
                                                        <th>Relationship with the member</th>
                                                        <th>Whether residing with him/her</th>
                                                        <th colSpan={2}>If 'No' state Place of Residence</th>
                                                        {
                                                            !readOnly && <th>Action</th>
                                                        }
                                                    </tr>
                                                    <tr>
                                                        <th colSpan={4}></th>
                                                        <th colSpan={1}>Town</th>
                                                        <th colSpan={1}>State</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {formValues[section]?.map((nominee, index) => {
                                                        return <tr key={index}>
                                                            <td>{nominee.member_name}</td>
                                                            <td>{dateConvert(nominee?.date_of_birth, "day-mon-year")} </td>
                                                            <td>{nominee.family_relation}</td>
                                                            <td>{nominee.eps2_is_residing_with_relative ? "No" : "Yes"}</td>
                                                            <td>{nominee.eps2_is_residing_with_relative ? nominee.eps2_residence_town || 'Not provided' : 'N/A'}</td>
                                                            <td>{nominee.eps2_is_residing_with_relative ? nominee.eps2_residence_state || 'Not provided' : 'N/A'}</td>
                                                            {
                                                                !readOnly && <td>  <FontAwesomeIcon
                                                                    icon="fa-solid fa-trash"
                                                                    style={{ cursor: "pointer" }}
                                                                    onClick={() => setShowPopup({ visibel: true, section, row: nominee })}
                                                                /> </td>
                                                            }
                                                        </tr>
                                                    })}
                                                </tbody>
                                            </table>
                                            <p style={{ fontSize: "14px", fontWeight: "600" }}>* Certified that I have no family, as defined in para 2(vii) of Employees’ Pension Scheme, 1995 and should I acquire a family hereafter I shall furnish particulars thereon in the above form.</p>
                                        </div>
                                    }
                                </div>
                            }
                        </>
                    }
                    )}
                </section>
                <section>
                    <div className='d-flex justify-content-between align-items-end'>
                        <p>Date:<strong>{dateConvert(data?.employee?.joining_date, "day-mon-year")}</strong></p>
                        <div>
                            <RenderSignatureField name="user_signature_url" handleChange={handleChange} value={signature} handleRemove={handleRemove} />
                            <p style={{ fontSize: "14px", fontWeight: "700" }}>Signature or thumb impression of the subscriber</p>
                        </div>
                    </div>
                    <div className='mt-4'>
                        <h5 style={{ fontSize: "14px", fontWeight: "700" }} className='text-decoration-underline text-center'>CERTIFICATE BY EMPLOYER</h5>
                        <p>Certified that the above declaration and nomination has been signed/thumb impressed before me by Shri/Smt./Kumari <strong>{data?.employee?.user_display_name}</strong> employed in my establishment after he/she has read the entries/the entries have been read over to him/her by me and got confirmed by him/her.</p>
                        <div className='d-flex justify-content-between align-items-end my-2'>
                            <div>
                                <p>Place: <strtong>{data?.commonDetails?.job_location}</strtong></p>
                                <p className='my-2'>Date:<strong>{dateConvert(data?.employee?.joining_date, "day-mon-year")}</strong></p>
                                <div className='my-2'>
                                    <p className='fw-semibold text-decoration-underline'>$ - Applicable if Married -&gt; To Spouse and Children (include children adopted legally before death in service</p>
                                    <p className='my-2 fw-semibold text-decoration-underline'>$ - Applicable to both Married and unmarried <br></br>(1) Married ----- To any person(s) other than spouse and children.<br></br>
                                        (2) Unmarried ----- To Parents, Brother, Sister or any other person(s).</p>
                                </div>
                            </div>
                            <div>
                                {!readOnly && <RenderSignatureField name="hr_sign" handleChange={handleChange} value={signature} handleRemove={handleRemove} />}
                                <p style={{ fontSize: "14px", fontWeight: "700" }}>Signature of the Employer or other authorised Officer of the establishment</p>
                                <div className='my-2'>
                                    <p> Designation: <strong>Group Head - Human Resources</strong></p>
                                    Name and address of the Factory/Establishment or rubber stamp thereof
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {
                    !readOnly && <div className='d-flex gap-2 justify-content-end position-fixed w90 bottom-0 end-0 px-4 pb-2 bg-white'>
                        <button className="btn-default" onClick={onPrev}>Previous</button>
                        <button className='btn-primary' onClick={onNext}>Proceed</button>
                    </div>
                }

            </div>

            <CommanDialog
                visible={showPopup?.visibel}
                message={"Are you sure you want to delete this?"}
                handleClose={() => setShowPopup({ visibel: false, section: "", row: "" })}
                handleFun={() => handleDelete(showPopup?.section, showPopup?.row)}
            />
        </div>
    )
}

export default ProvidentFund
